import union from 'lodash/union';
import mapValues from 'lodash/mapValues';

export default offers => {
  return union(...Object.values(mapValues(offers, 'systemsList'))) || [];
};
